<script lang="ts">
  import type { Flashcard } from '../../types/flashcard';
  import type { ExerciseSessionConfig } from '../../types/exercise';
  import { X } from 'lucide-svelte';
  import { _ } from 'svelte-i18n';
  import ExerciseScreen from '../ExerciseScreen.svelte';

  let {
    open = false,
    flashcards,
    config = {},
    onClose = () => {},
  }: {
    open?: boolean;
    flashcards: Flashcard[];
    config?: Partial<ExerciseSessionConfig>;
    onClose?: () => void;
  } = $props();

  function handleClose() {
    onClose?.();
  }

  function handleBackdropClick(event: MouseEvent) {
    // Don't close on backdrop click for exercises
    // Users might accidentally click while taking a test
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      handleClose();
    }
  }
</script>

{#if open}
  <div
    class="fixed inset-0 z-[96] flex flex-col dialog-overlay"
    role="dialog"
    aria-modal="true"
    tabindex="0"
    onclick={handleBackdropClick}
    onkeydown={handleKeydown}
  >
    <div class="dialog-close dialog-close--fixed">
      <button
        type="button"
        class="btn btn-close"
        onclick={handleClose}
        aria-label={$_('buttons.cancel')}
      >
        <X class="h-5 w-5" />
      </button>
    </div>

    <div class="h-full w-full overflow-hidden">
      <ExerciseScreen
        {flashcards}
        {config}
        onBack={handleClose}
      />
    </div>
  </div>
{/if}
